module.exports = __webpack_public_path__ + "static/media/01.cda0db5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/volumetric/baggage/01.png
// module id = 626
// module chunks = 0